var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppTabs',{attrs:{"value":_vm.value,"tabs":_vm.tabs},on:{"input":function ($event) { return _vm.$router.push({ name: $event.key }); }}}),_c('hr',{staticClass:"mt-3 mb-3"}),_c('KeepAlive',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }